import { BtixConstant } from "../constant";
/**
 * 左ナビのサブメニュー表示部分
 *
 * 高さが固定になっており、CSSだけでは対応できなかったためJSで中身をすげ替えている
 */
export const activateLeftNaviSubMenu = () => {
    const topLayerMenues = document.querySelectorAll("main aside .list-menu > li");
    const topLayerAnchors = document.querySelectorAll("main aside .list-menu > li > a");
    // サブメニューがないパターンが存在し得るためErrorではなくログ出力に留めている
    if (!topLayerMenues && BtixConstant.debugMode)
        window.console.log("NOTICE: 'topLayer' is not found.");
    // メニュー表示エリアを初期化（子、孫の存在確認も併せて実施）
    const rootArea = document.querySelector("main aside .list-submenu-area");
    if (!rootArea)
        return;
    const secondArea = rootArea.querySelector(".list-submenu-area-second");
    if (!secondArea)
        throw new Error("'secondArea' is not found.");
    const thirdArea = rootArea.querySelector(".list-submenu-area-third");
    if (!thirdArea)
        throw new Error("'thirdArea' is not found.");
    // サブメニューの初期化を行う
    setupSecondLevelSubMenues(topLayerMenues, secondArea, thirdArea);
    // サブメニューがない時はサブメニューを非表示にする
    // 本来は :hover でやるべきだが、JSでの処理が必要になってしまったため仕方なくの処置
    topLayerMenues.forEach((topLayerMenu) => {
        topLayerMenu.addEventListener("mouseenter", (event) => {
            // サブメニューを初期化
            clearSubMenu(secondArea);
            // メニュー選択色を全て一旦解除
            topLayerAnchors.forEach((anchor) => {
                anchor.classList.remove("active");
            });
            // 選択されているメニューの色固定
            const target = event.target;
            const anchor = target.querySelector(":scope > a");
            anchor.classList.add("active");
            // サブメニューを持たない場合は強制的にサブメニューを閉じる
            const subMenuList = topLayerMenu.querySelector(".list-submenu");
            if (!subMenuList)
                clearSubMenu(secondArea, thirdArea);
        });
    });
    // サブメニューが閉じられた時の動作を入れておく
    setupCloseLeftNaviSubMenu(topLayerAnchors, secondArea, thirdArea);
};
// 子メニューセットアップ用
// MEMO: 本当は一発で全ての初期化をやりたかったのだが、今回疑似DOMを使っていないのでappend時に都度初期化している
// MEMO: 最近のブラウザはここまでしなくても適宜メモリを解放してくれるはずだが、念のため
const setupSecondLevelSubMenues = (rootMenues, secondArea, thirdArea) => {
    rootMenues.forEach((topLayerMenu) => {
        const anchor = topLayerMenu.querySelector(":scope > a");
        if (!anchor)
            return; // リンク先がない場合に対応している
        const subMenu = topLayerMenu.querySelector(":scope > .list-submenu");
        // サブメニューがないパターンが存在し得るためErrorではなくログ出力に留めている
        // if (!subMenu && BtixConstant.debugMode) window.console.log("NOTICE: 'subMenu (second)' is not found.");
        anchor.addEventListener("mouseenter", () => {
            clearSubMenu(thirdArea);
            // 孫メニューがあれば差し替える
            if (subMenu instanceof HTMLDivElement) {
                const _subMenu = subMenu.cloneNode(true);
                secondArea.appendChild(_subMenu);
                setupThirdLevelSubMenues(secondArea, thirdArea);
            }
        });
    });
};
// 孫メニューセットアップ用
const setupThirdLevelSubMenues = (secondArea, thirdArea) => {
    const subMenues = secondArea.querySelectorAll(".list-menu > li");
    if (!subMenues)
        throw new Error("'subMenues' is not found.");
    subMenues.forEach((menu) => {
        const anchor = menu.querySelector(":scope > a");
        if (!anchor)
            return; // リンク先がない場合に対応している
        const subMenu = menu.querySelector(":scope > .list-submenu");
        // サブメニューがないパターンが存在し得るためErrorではなくログ出力に留めている
        // if (!subMenu && BtixConstant.debugMode) window.console.log("NOTICE: 'subMenu (third)' is not found.");
        // サブメニューがない時はメニューを閉じる
        anchor.addEventListener("mouseenter", () => {
            clearSubMenu(thirdArea);
            if (subMenu instanceof HTMLDivElement) {
                const _subMenu = subMenu.cloneNode(true);
                if (subMenu)
                    thirdArea.appendChild(_subMenu);
            }
        });
    });
};
// サブメニューの表示内容を削除する
const clearSubMenu = (...areas) => {
    areas.forEach((element) => {
        element.innerHTML = "";
    });
};
// 領域外にマウスが行ったらメニューを閉じる
// 左サブメニューの領域は特殊なので、querySelectorでしっかりハンドリングしておく
const setupCloseLeftNaviSubMenu = (topLayerAnchors, secondArea, thirdArea) => {
    const mouseMoveWatchArea = document.querySelector("body");
    const leftNaviMenuAreaClass = ".list-menu, .list-submenu-area";
    // マウスイベント監視を開始
    let mouseMoveWatching = false;
    const startMouseMoveWatcher = () => {
        if (mouseMoveWatching)
            return;
        mouseMoveWatching = true;
        window.console.log("start!");
        mouseMoveWatchArea.addEventListener("mousemove", mouseMoveWatcher);
    };
    const leftNaviMenu = document.querySelector("main aside .list-menu");
    leftNaviMenu.addEventListener("mouseover", startMouseMoveWatcher);
    // マウスイベント監視を終了
    const removeMouseMoveWatcher = () => {
        window.console.log("remove!");
        mouseMoveWatching = false;
        mouseMoveWatchArea.removeEventListener("mousemove", mouseMoveWatcher);
    };
    let timeoutId;
    const mouseMoveWatcher = (event) => {
        if (timeoutId)
            return;
        timeoutId = window.setTimeout(function () {
            timeoutId = 0;
            const target = event.target;
            if (!target.closest(leftNaviMenuAreaClass)) {
                clearSubMenu(secondArea, thirdArea);
                topLayerAnchors.forEach((anchor) => {
                    anchor.classList.remove("active");
                });
                removeMouseMoveWatcher();
            }
        }, 100);
    };
};
